<script>
import conPresentation from 'gkConUI/con-presentation'
import utils from '@/utils'

import { mapState } from 'vuex'

export default {
  data () {
    return {
    }
  },
  components: {
    conPresentation
  },
  props: [
    'id'
  ],
  computed: {
    ...mapState(['config', 'lectures']),
    lecture () {
      return this.lectures[this.id]
    }
  },
  updated () {},
  mounted () {},
  watch: {
    lecture () {
      utils.weixinshare({
        imgUrl: this.lecture.speaker.avatar,
        title: this.lecture.title + this.config.wechat_share.default_title
      })
    }
  },
  render () {
    return (<con-presentation {...{ props: { id: this.id } }}/>)
  }
}
</script>
